import React from "react";
import { ImFilePdf } from "react-icons/im";
import { v4 as uuidv4 } from "uuid";
import { ControlPanel } from "./ControlPanel";
import { PreviewPlayer } from "./PlayerPreview";
import { PlayerDevice } from "./Player";
import { AddPreview } from "./AddPreview/AddPreview";
export const PdfWidget = {
    id: "fd7569bb-0b36-4a2e-9a50-f133a2e955bc",
    name: "Pdf",
    icon: React.createElement(ImFilePdf, null),
    type: "pdf",
    inHeadbar: true,
    description: "Ajout d'un PDF",
    config: null,
    createdAt: "2022-07-18T08:03:18.585Z",
    updatedAt: "2022-07-18T08:03:18.585Z",
    isActive: true,
    isDeleted: false,
    load: null,
    scope: ["font"],
    controlPanel: ControlPanel,
    playerPreview: PreviewPlayer,
    context: null,
    playerDevice: PlayerDevice,
    addWidgetPreview: [AddPreview],
    contextDevice: ({ children }) => React.createElement(React.Fragment, null, children),
    factory: () => ({
        id: uuidv4(),
        data: {
            numPages: 0,
            pagesTransitionDelay: 10,
        },
    }),
};
